import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import type { Id } from 'convex/_generated/dataModel'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import PlanDetailPage from '@/features/plans/components/PlanDetailPage'

export const Route = createFileRoute('/_authed/plans/$planId')({
  loader: async ({ context, params }) => {
    const planId = params.planId as Id<'plans'>
    await Promise.all([
      context.queryClient.ensureQueryData(convexQuery(api.plans.getPlan, { planId })),
      context.queryClient.ensureQueryData(convexQuery(api.plans.getPlanStats, { planId })),
      context.queryClient.ensureQueryData(convexQuery(api.plans.getLinkableTasksForPlan, { planId })),
    ])
  },
  pendingComponent: () => <LoadingScreen message="Loading plan..." />,
  component: PlanDetailRouteWrapper,
})

function PlanDetailRouteWrapper() {
  const { planId } = Route.useParams()
  return (
    <Suspense fallback={<LoadingScreen message="Loading plan..." />}>
      <PlanDetailPage planId={planId as Id<'plans'>} />
    </Suspense>
  )
}
